import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#007754",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3",
      d: "M22.86 4.72a3.22 3.22 0 0 0-3.22-3.22 3.22 3.22 0 0 0-3.2 3.22v24.1l-5.24-4.18a3.3 3.3 0 0 0-4.8.74 3.3 3.3 0 0 0 0 3.66l7.82 11.74a12.84 12.84 0 0 0 10.7 5.72h6.26a11 11 0 0 0 7.76-3.22 10.94 10.94 0 0 0 3.2-7.76V20.78a3.2 3.2 0 0 0-3.2-3.2 3.22 3.22 0 0 0-3.22 3.2v-1.6A3.22 3.22 0 0 0 32.5 16a3.22 3.22 0 0 0-3.2 3.22A3.22 3.22 0 0 0 26 16a3.22 3.22 0 0 0-3.22 3.22zm0 14.46V24m6.439-4.82V24m6.42-3.22V24"
    }, null, -1)
  ])))
}
export default { render: render }